import { Url } from '../general/modules/url';

export function getUrlToLoginViaToken(token: string, suid: string = '') {
    let path = `/login/bytokenoauth/?token=${token}`;
    if (suid) {
        path += `&suid=${suid}`;
    }
    return Url.getSiteNoLangUrl(path);
}

